import StatusesManagementPage from './StatusesManagementPage';

export default StatusesManagementPage;
